import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BsFillShieldLockFill } from "react-icons/bs";
import { CgSpinner } from "react-icons/cg";
import OtpInput from "otp-input-react";
import "react-phone-input-2/lib/style.css";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { toast, Toaster } from "react-hot-toast";

import { auth } from "../../../firebase.config";

const OtpVerifications = () => {
  const location = useLocation()
  const [otp, setOtp] = useState("");
  const [ph, setPh] = useState(location.state?.phone);
  const [loading, setLoading] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [user, setUser] = useState(null);
  const phone     = location.state?.phone
  const lastlogin = location.state?.lastlogin
  const data      = location.state?.data
  let navigate = useNavigate();


  
  function onCaptchVerify() {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => {
            onSignup();
          },
          "expired-callback": () => {},
        },
        auth
      );
    }
  }

  function onSignup() {
    setLoading(true);
    onCaptchVerify();

    const appVerifier = window.recaptchaVerifier;

    const formatPh = "+" + ph;

    signInWithPhoneNumber(auth, formatPh, appVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;
        setLoading(false);
        setShowOTP(true);
        toast.success("OTP sended successfully!");
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }
  useEffect(()=>{
    // if(ph){
        localStorage.setItem("last_login",data.lastlogin)

      onSignup()
    // }
  },[])

  function onOTPVerify() {
    setLoading(true);
    window.confirmationResult
      .confirm(otp)
      .then(async (res) => {
        setUser(res.user);
        setLoading(false);
        localStorage.setItem("user",JSON.stringify(data));
        localStorage.setItem("username",JSON.stringify(data.username));
        localStorage.setItem("locale",data.locale)
        localStorage.setItem("currency",data.currency)
        localStorage.setItem("companyid",data.companyid)
        localStorage.setItem("parent",data.parent)
        localStorage.setItem("permissions",data.permissions)
        localStorage.setItem("customer",data.customer)
        localStorage.setItem("userid",data.user_id)
        localStorage.setItem("last_login",data.lastlogin)
        if (lastlogin === null) {
          navigate("/changepwd");
        } else {
          navigate("/");
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }

  return (

    // <div className="container-fluid bg-emerald-500 flex items-center justify-center h-screen">
    // <div className="container-fluid justify-content-center">
//     <>
//     {showOTP ?  (
//       <div className="text-center mb-5 tc pt-4">
//       <div className="col-sm-12">

//       <div className=" card text-center" style={{display: "inline-flex"}} >
//       <div className=" card-body text-center" >
//         <Toaster toastOptions={{ duration: 4000 }} />
//         <div id="recaptcha-container"></div>
//         {user ? (
//           <h2 className="text-center text-white font-medium text-2xl">
//             👍Login Success
//           </h2>
//         ) : <>
//            <div className="bg-blue text-center  p-4 rounded-full">
//                   <BsFillShieldLockFill size={30} />
//                 </div>
//           <div className="wi20 flex flex-col gapL-4 rounded-lg p-4">
//             <h2 className="text-center ">
//             2-step verification
//             </h2>
//             <h4 className="text-center">

//               <br /> We sent a verification code to your email.

//               <br/>Please enter the code in the field below.
//             </h4>
//             {/* {showOTP ? ( */}
//               <>
             
//                 {/* <label
//                   htmlFor="otp"
//                   className="font-bold text-xl text-black mt-2 text-center"
//                 >
//                   Enter your OTP
//                 </label> */}
//                 <div className="text-center mt-3">

//                 <OtpInput
//                   value={otp}
//                   onChange={setOtp}
//                   OTPLength={6}
//                   otpType="number"
//                   disabled={false}
//                   autoFocus
//                   className="opt-container  "
//                   ></OtpInput>
//                   </div>
//                 <button
//                   onClick={onOTPVerify}
//                   className="btn btn-primary mt-2 "
//                 >
//                   {loading && (
//                     <CgSpinner size={20} className="mt-1 animate-spin" />
//                   )}
//                   <span>Verify OTP</span>
//                 </button>
              
//               </>
//           </div>
//           </>
//           }
//           </div>
//           </div>
//           </div>
//           {/* )} */}
//           </div>
//         ):
      
//     <>
//     {/* <Toaster toastOptions={{ duration: 4000 }} /> */}
//     </>
// }
//     {/* // </div> */}
//     </>
<section className="text-center mb-5 tc pt-4">
      <div className="col-sm-12">
            <div className=" card text-center" style={{display: "inline-flex"}} >

        <Toaster toastOptions={{ duration: 4000 }} />
        <div id="recaptcha-container"></div>
        {user ? (
          <h2 className="text-center text-black font-medium text-2xl">
            👍Login Success
          </h2>
        ) : (
          <div className="flex flex-col gap-4 rounded-lg p-4">
            {/* <h1 className="text-center leading-normal text-white font-medium text-3xl mb-6">
              Welcome to <br /> CODE A PROGRAM
            </h1> */}
            <div className="bg-blue text-center  p-4 rounded-full">
                   <BsFillShieldLockFill size={30} />
                 </div>
               <h2 className="text-center ">
             2-step verification
            </h2>
             <h4 className="text-center">

                            <br /> We sent a verification code to your email.

               <br/>Please enter the code in the field below.
             </h4>
            {showOTP ? (
              <>
              <div className="col-sm-12">
            <div className=" card text-center" style={{display: "inline-flex",border:"none !important"}} >
                {/* <div className="bg-white text-emerald-500 w-fit mx-auto p-4 rounded-full">
                  <BsFillShieldLockFill size={30} />
                </div> */}
                {/* <label
                  htmlFor="otp"
                  className="font-bold text-xl text-white text-center"
                >
                  Enter your OTP
                </label> */}
                <div className="text-center mt-3">

                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  OTPLength={6}
                  otpType="number"
                  disabled={false}
                  autoFocus
                  className="opt-container "
                  ></OtpInput>
                  </div>
                <button
                  onClick={onOTPVerify}
                  className="btn btn-primary mt-2"
                >
                  {loading && (
                    <CgSpinner size={20} className="mt-1 animate-spin" />
                  )}
                  <span>Verify OTP</span>
                </button>
                </div>
                </div>
              </>
            ) : (
              <>
                {/* <div className="bg-white text-emerald-500 w-fit mx-auto p-4 rounded-full">
                  <BsTelephoneFill size={30} />
                </div>
                <label
                  htmlFor=""
                  className="font-bold text-xl text-white text-center"
                >
                  Verify your phone number
                </label>
                <PhoneInput country={"in"} value={ph} onChange={setPh} />
                <button
                  onClick={onSignup}
                  className="bg-emerald-600 w-full flex gap-1 items-center justify-center py-2.5 text-white rounded"
                >
                  {loading && (
                    <CgSpinner size={20} className="mt-1 animate-spin" />
                  )}
                  <span>Send code via SMS</span>
                </button> */}
              </>
            )}
          </div>
        )}
      </div>
      </div>
    </section>
  );
};

export default OtpVerifications;
